
import React, { Component } from "react";
import { connect } from "react-redux";
import { customerService } from "../../services";
import axios from "axios";
import "./Upspi26.scss";

class Upspi26 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            status: null, // 'authorized' | 'redeemed' | 'notfound'
            showCodeModal: false, // ควบคุมการแสดงโมดัลกรอกรหัส
            codeDigits: ["", "", "", ""], // เก็บเลขแต่ละช่อง
            amwayNumber: null,
            partyId: null,

            screen: "pass",
            cusNotfound: false,
            errorText: "",
            isCheckingPass: false,
        };
    }

    preloadImages = () => {
        const images = [
            "/images/upspiration/upspi26-bg.png",
            "/images/upspiration/upspi26-gif.png",
            "/images/upspiration/upspi26-notfound.png",
            "/images/upspiration/upspi26-notregister.png",
            "/images/upspiration/upspi26-redeemed.png",
        ];

        return Promise.all(
            images.map(
                (src) =>
                    new Promise((resolve) => {
                        const img = new Image();
                        img.src = src;
                        img.onload = resolve;
                        img.onerror = resolve; // ไม่ให้ค้างถ้าโหลดรูปใดรูปหนึ่งไม่ได้
                    })
            )
        );
    };

    componentDidMount() {
        this.preloadImages();
        this.checkCustomer();
    }

    componentDidUpdate(prevProps) {
        if (this.props.profile.userId !== prevProps.profile.userId) {
            this.checkCustomer();
        }
    }

    checkCustomer() {
        console.log("checkCustomer called...", this.props)
        const { profile } = this.props;
        if (!profile?.userId) return;
        let customerType = "";
        customerService
            .get(profile.userId)
            .then((res) => {
                console.log("res", res);
                if (!res) {
                    this.setState({ status: "notregister" });
                    return;
                }
                customerType = res.type;
                if (res && res._id && ["abo", "member"].includes(res.type)) {
                    this.setState({
                        amwayNumber: res.amwayNumber,
                        partyId: res.partyId,
                    });
                    return axios.post(
                        `${process.env.REACT_APP_API_URL}/customers/upspiration`,
                        {
                            uid: profile.userId,
                            amwayNumber: res.amwayNumber,
                            partyId: res.partyId,
                        }
                    );
                } else if (res && res._id && ["public"].includes(res.type)) {

                    return axios.post(
                        `${process.env.REACT_APP_API_URL}/customers/upspiration`,
                        {
                            uid: profile.userId,
                            amwayNumber: res.amwayNumber,
                            partyId: res.partyId,
                        }
                    );

                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .then((response) => {
                if (!response) return;
                const data = response.data;
                if (data === "คุณได้รับสิทธิ์") {
                    this.setState({ status: "authorized" });
                } else if (data === "คุณใช้งานไปแล้ว") {
                    this.setState({ status: "redeemed" });
                } else if (data === "ไม่พบข้อมูลของคุณ" && customerType === "public") {
                    this.setState({ status: "authorized" });
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .catch(() => {
                this.setState({ status: "notregister" });
            });
    }

    handleConfirm = () => {
        this.setState({ showCodeModal: true }, () => {
            if (this.digit0) {
                this.digit0.focus();
            }
        });
    };

    // ปิดโมดัล
    handleCancelCode = () => {
        this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            // เบราว์เซอร์ทั่วไป
            window.close();
        }
    };
    // อัปเดตเลขแต่ละช่อง
    handleDigitChange = (idx, e) => {
        const v = e.target.value.replace(/\D/, "").slice(-1);
        const code = [...this.state.codeDigits];
        code[idx] = v;
        this.setState({ codeDigits: code }, () => {
            // ถ้ากรอกครบ จะโฟกัสช่องถัดไปอัตโนมัติ
            if (v && idx < 3) {
                this[`digit${idx + 1}`].focus();
            }
        });
    };

    // ส่งรหัสไปตรวจสอบหรือแลกของรางวัล
    handleSubmitCode = () => {
        const code = this.state.codeDigits.join("");
        const { profile } = this.props;
        const { amwayNumber, partyId } = this.state;

        axios.post(
            `${process.env.REACT_APP_API_URL}/customers/upspiration_update`,
            {
                uid: profile.userId,
                amwayNumber: amwayNumber,
                partyId: partyId,
                user: code,
            }
        )
            .then((res) => {
                const msg = res.data;
                // อัปเดต status ตามที่ backend ส่งกลับ
                if (msg === "คุณได้รับสิทธิ์") {
                    this.setState({ status: "redeemed" });
                } else if (msg === "คุณใช้งานไปแล้ว") {
                    this.setState({ status: "redeemed" });
                } else if (msg === "สถานะข้อมูลไม่ชัดเจน") {
                    this.setState({ status: "authorized" });
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .catch((err) => {

                this.setState({ status: "notregister" });
            })
            .finally(() => {
                // ปิด modal และรีเซ็ต codeDigits ทุกกรณี
                this.setState({ showCodeModal: false, codeDigits: ["", "", "", ""] });
            });
    };

    handleClose = () => {
        if (window.liff && typeof window.liff.closeWindow === "function") {
            window.liff.closeWindow();
        } else {
            // เบราว์เซอร์ทั่วไป
            window.close();
        }
    };

    renderCodeModal() {
        const { codeDigits } = this.state;
        return (
            <div className="modalOverlay">
                <div className="modalBox">
                    <p className="modalTitle">
                        ระบุรหัสสำหรับการแลกของรางวัล
                    </p>
                    <p className="modalSubtitle">
                        กรุณาให้เจ้าหน้าที่เป็นผู้กรอกรหัสและกดแลกของรางวัล
                    </p>
                    <div className="codeRow">
                        {codeDigits.map((d, i) => (
                            <input
                                key={i}
                                ref={(ref) => (this[`digit${i}`] = ref)}
                                type="password"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={1}
                                value={d}
                                onChange={(e) => this.handleDigitChange(i, e)}
                                onKeyDown={(e) => {
                                    if (e.key === "Backspace" && !e.target.value && i > 0) {
                                        if (this[`digit${i - 1}`]) { this[`digit${i - 1}`].focus(); }
                                    }
                                }}
                                className="codeInput"
                            />
                        ))}
                    </div>
                    <div className="modalActions">
                        <div className="btnContainer">
                            <button
                                className="btnOverlayCancel"
                                onClick={this.handleCancelCode}
                            />
                            <button
                                className="btnOverlaySubmit"
                                onClick={this.handleSubmitCode}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderLoading() {
        return (
            <div className="upspi26 fullscreen">
                <div className="bgUpspi26Loading" />
            </div>
        );
    }

    renderAuthorized() {
        return (
            <div className="upspi26 fullscreen">
                <div className="containerAuthorized">
                    <div className="upspi26AuthorizedPage">
                        <img
                            className="upspi26GiftImg"
                            src="/images/upspiration/upspi26-gif.png"
                            alt=""
                        />

                        <div className="upspi26CodeText">
                            ให้เจ้าหน้าที่กรอกโค้ด
                            <br />
                            เพื่อรับของที่ระลึก
                        </div>

                        {this.renderPassPanel()}
                    </div>
                </div>
            </div>
        );
    }

    renderRedeemed() {
        return (
            <div className="upspi26 fullscreen">
                <div className="containerAuthorized">
                    <div className="upspi26AuthorizedPage">
                        <img
                            className="upspi26GiftRedeemedImg"
                            src="/images/upspiration/upspi26-redeemed.png"
                            alt=""
                        />


                    </div>
                </div>
            </div>
        );
    }

    renderNotFound() {
        return (
            <div className="upspi26 fullscreen">
                <div className="containerAuthorized">
                    <div className="upspi26AuthorizedPage">
                        <img
                            className="upspi26GiftNotfoundImg"
                            src="/images/upspiration/upspi26-notfound.png"
                            alt=""
                        />


                    </div>
                </div>
            </div>
        );
    }

    renderNotRegister() {
        return (
            <div className="upspi26 fullscreen">
                <div className="containerAuthorized">
                    <div className="upspi26AuthorizedPage">
                        <img
                            className="upspi26GiftNotfoundImg"
                            src="/images/upspiration/upspi26-notregister.png"
                            alt=""
                        />


                    </div>
                </div>
            </div>
        );
    }


    handlePassChange = (idx, value) => {
        const v = value.replace(/\D/g, "").slice(-1);
        const code = [...this.state.codeDigits];

        code[idx] = v;

        this.setState({ codeDigits: code, errorText: "" }, () => {
            if (v && idx < 3 && this[`digit${idx + 1}`]) {
                this[`digit${idx + 1}`].focus();
            }
        });
    };

    handlePassKeyDown = (idx, e) => {
        if (e.key === "Backspace" && !e.target.value && idx > 0) {
            if (this[`digit${idx - 1}`]) {
                this[`digit${idx - 1}`].focus();
            }
        }
    };

    onClickCheckPass = () => {
        const passComplete = this.state.codeDigits.every(Boolean);

        if (!passComplete || this.state.isCheckingPass) return;

        this.handleSubmitCode();
    };


    handleSubmitCode = () => {
        const code = this.state.codeDigits.join("");
        const { profile } = this.props;
        const { amwayNumber, partyId } = this.state;

        if (code.length !== 4) {
            this.setState({ errorText: "กรุณากรอกรหัสให้ครบ 4 หลัก" });
            return;
        }

        this.setState({ isCheckingPass: true, errorText: "" });

        axios.post(
            `${process.env.REACT_APP_API_URL}/customers/upspiration_update`,
            {
                uid: profile.userId,
                amwayNumber,
                partyId,
                user: code,
            }
        )
            .then((res) => {
                const msg = res.data;

                if (msg === "คุณได้รับสิทธิ์" || msg === "คุณใช้งานไปแล้ว") {
                    this.setState({ status: "redeemed" });
                } else if (msg === "สถานะข้อมูลไม่ชัดเจน") {
                    this.setState({
                        status: "authorized",
                        errorText: "รหัสไม่ถูกต้อง กรุณาลองใหม่",
                    });
                } else {
                    this.setState({ status: "notfound" });
                }
            })
            .catch(() => {
                this.setState({
                    status: "authorized",
                    errorText: "เกิดข้อผิดพลาด กรุณาลองใหม่",
                });
            })
            .finally(() => {
                this.setState({
                    isCheckingPass: false,
                    codeDigits: ["", "", "", ""],
                });
            });
    };

    renderPassPanel() {
        const { codeDigits, screen, cusNotfound, errorText, isCheckingPass } = this.state;
        const passComplete = codeDigits.every(Boolean);

        return (
            <>
                {(!cusNotfound && (screen === "pass" || screen === "passBlack")) && (
                    <div className="upspi26codeUpspi26Panel">
                        <div className="upspi26codeAgrRow">
                            {codeDigits.map((v, idx) => (
                                <input
                                    key={idx}
                                    ref={(el) => (this[`digit${idx}`] = el)}
                                    className="upspi26cAgrodeInput"
                                    inputMode="numeric"
                                    value={v}
                                    onChange={(e) => this.handlePassChange(idx, e.target.value)}
                                    onKeyDown={(e) => this.handlePassKeyDown(idx, e)}
                                    maxLength={1}
                                    type="password"
                                />
                            ))}
                        </div>

                        <button
                            type="button"
                            className={`upspi26SubmitBtn ${passComplete ? "enabled" : "disabled"}`}
                            disabled={!passComplete || isCheckingPass}
                            onClick={this.onClickCheckPass}
                        >
                            รับของที่ระลึก
                        </button>

                        {errorText && (
                            <div className="upspi26errorText">
                                {errorText}
                            </div>
                        )}
                    </div>
                )}

                {screen === "passBlack" && (
                    <div
                        className={`upspi26enterHit ${passComplete && !isCheckingPass ? "enabled" : "disabled"}`}
                        onClick={this.onClickCheckPass}
                        role="button"
                    />
                )}
            </>
        );
    }

    render() {
        const { status } = this.state;

        if (status === null) {
            return this.renderLoading();
        }

        return (
            <>
                {status === "authorized" && this.renderAuthorized()}
                {status === "redeemed" && this.renderRedeemed()}
                {status === "notfound" && this.renderNotFound()}
                {status === "notregister" && this.renderNotRegister()}
            </>
        );
    }
}



const mapStateToProps = (state) => ({
    profile: state.profile,
});

export default connect(mapStateToProps)(Upspi26);


